import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 6.5h1v6.102L11.5 13V8h-7v5h7l.406 1.5H3v-8h1V5.466C4 3.28 5.676 1.5 7.923 1.5 10.171 1.5 12 3.349 12 5.622V6.5Zm-6.5 0h5v-.878C10.5 4.176 9.345 3 7.923 3 6.587 3 5.5 4.106 5.5 5.466V6.5Zm1.59 3.472 1.438-.382.382 1.438-1.438.381-.381-1.437Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as Security
};
